// extracted by mini-css-extract-plugin
module.exports = {"mainTimeContainer":"TimeRightNow-module--mainTimeContainer--KDv0R","TimeContainer":"TimeRightNow-module--TimeContainer--mWAPR"};